/**
 * Version information for flexcoa-client.
 * The version is stamped into the build from git history by vite.config.js
 * (see scripts/app-version.js), so it never needs bumping by hand.
 */

// Version string in format "X.Y.Z"
export const VERSION_STRING = import.meta.env.VITE_APP_VERSION || '0.0.0';

// Current version as an array [major, minor, patch]
export const VERSION = VERSION_STRING.split('.').map(Number);

/**
 * Returns the current version string.
 * @returns {string} Version string in format "X.Y.Z"
 */
export function getVersion() {
  return VERSION_STRING;
}

/**
 * Returns detailed version information.
 * @returns {Object} Version information object
 */
export function getVersionInfo() {
  return {
    version: VERSION_STRING,
    environment: import.meta.env.MODE || 'development',
  };
}
